import { css } from "@compiled/react";

import { B300, B400, P500 } from "@atlaskit/theme/colors";

import { wacToken } from "@/libraries/design/foundations";
import { Logo } from "@/libraries/wpl/foundations/src/logo";

import { ContactSupport } from "./sections/contact-support";
import { EmailButtons } from "./sections/email-buttons";
import { EmailedYou } from "./sections/emailed-you";

const ContainerStyle = css({
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    alignSelf: "center"
});

const InnerStyle = css({
    alignItems: "stretch",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    padding: "3rem",
    fontWeight: "normal",
    fontFamily: wacToken("font.charlie.text"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        "alignItems": "center",
        "background": "none",
        "border": 0,
        "color": `${B300}`,
        "display": "inline-flex",
        "fontSize": "100%",
        "letterSpacing": 0,
        "lineHeight": "24px",
        "margin": 0,
        "padding": 0,
        "textAlign": "center",
        "textDecoration": "none",

        "&:hover": {
            cursor: "pointer",
            color: `${B400}`
        },
        "&:focus": {
            color: `${B400}`
        },
        "&:visited": {
            color: `${P500}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "svg path": {
            fill: `${B300}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "&:hover svg path": {
            fill: `${B400}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "&:focus svg path": {
            fill: `${B400}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "&:visited svg path": {
            fill: `${P500}`
        }
    }
});

export const CheckemailPageTemplate = () => {
    return (
        <div css={ContainerStyle}>
            <div css={InnerStyle}>
                <div>
                    <Logo
                        type={"logo"}
                        appearance={"brand"}
                        brand={"atlassian"}
                    />
                </div>
                <EmailedYou />
                <EmailButtons />
                <ContactSupport />
            </div>
        </div>
    );
};
